import styled, { css } from 'styled-components';

export const Container = styled.div`
    height: 100%;
    display: flex;
    min-height: 100vh;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const Title = styled.p`
    ${({ theme }) => css`
        font-size: ${theme.fontSizes.big};
        color: ${theme.colors.darkFont};
        align-self: center;
    `}
`;

export const ContainerImage = styled.div`
    justify-content: center;
    align-items: center;
    display: flex;

    img {
        width: 80%;
        border-radius: 1rem;
    }
`;

export const Wrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        height: fit-content;
        flex-direction: column;
        width: 100%;
        background-color: ${theme.colors.white};
        max-width: 44rem;
        padding: 2.6rem;
        border-radius: 12px;
        border: 1px solid rgba(0, 0, 0, 0.125);
        box-shadow: 0 4px 10px 0 rgb(20 19 34 / 3%),
            0 0 10px 0 rgb(20 19 34 / 2%);
        -webkit-box-shadow: 0 4px 10px 0 rgb(20 19 34 / 3%),
            0 0 10px 0 rgb(20 19 34 / 2%);
        -moz-box-shadow: 0 4px 10px 0 rgb(20 19 34 / 3%),
            0 0 10px 0 rgb(20 19 34 / 2%);
    `}
`;

export const SignUpText = styled.p`
    ${({ theme }) => css`
        font-size: ${theme.fontSizes.default};
        color: ${theme.colors.font};
        margin-top: 2rem;
        text-align: center;
    `}
`;

export const Footer = styled.p``;
